import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  trainerName: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "100%"
  },
  trainerComment: {
    width: "14px",
    height: "16px",
    marginLeft: "6px",
    "&:hover": {
      cursor: "pointer"
    }
  }
});
